import { useOfflineStatus } from '../hooks/useOfflineStatus';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';

export function OfflineIndicator() {
  const { isOnline, pendingCount, isSyncing, syncNow } = useOfflineStatus();

  const handleClick = () => {
    syncNow();
  };

  const ariaLabel = isOnline
    ? pendingCount > 0
      ? `Online, ${pendingCount} pending change${pendingCount !== 1 ? 's' : ''}${isSyncing ? ', syncing' : ''}`
      : `Online${isSyncing ? ', syncing' : ''}`
    : `Offline${pendingCount > 0 ? `, ${pendingCount} pending change${pendingCount !== 1 ? 's' : ''}` : ''}`;

  return (
    <button
      onClick={handleClick}
      disabled={!isOnline || isSyncing}
      aria-label={ariaLabel}
      className="flex items-center gap-1.5 px-2 sm:px-3 h-9 rounded-lg text-sm font-medium text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      title={ariaLabel}
    >
      {isOnline ? (
        <Wifi size={14} className="shrink-0" />
      ) : (
        <WifiOff size={14} className="shrink-0" />
      )}

      <span
        className={`h-2 w-2 rounded-full shrink-0 ${
          isOnline ? 'bg-emerald-500' : 'bg-orange-500'
        }`}
      />

      <span className="hidden sm:inline">
        {isOnline ? 'Online' : 'Offline'}
      </span>

      {pendingCount > 0 && (
        <span className="flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-slate-200 dark:bg-slate-700 text-[11px] font-semibold text-slate-600 dark:text-slate-300 leading-none">
          {pendingCount}
        </span>
      )}

      {isSyncing && (
        <RefreshCw size={13} className="animate-spin shrink-0" />
      )}
    </button>
  );
}
